import { useRouter } from "next/router"
import { type PropsWithChildren } from "react"
import { ConditionalWrapper } from "@/components/atoms"
import { AppLayout } from "@/features/navigation"
import { getQuerylessPath } from "@/lib/routes"
import {
    MeterPowerAnalysisRouteGuard,
    meterPowerAnalysisSteps,
    MeterPowerAnalysisWizardProvider,
} from "../../wizard"

type MeterPowerAnalysisLayoutProps = PropsWithChildren<{
    isWrapperDisplayed?: boolean
}>

export const MeterPowerAnalysisLayout = ({
    children,
    isWrapperDisplayed = true,
}: MeterPowerAnalysisLayoutProps) => {
    const router = useRouter()

    return (
        <MeterPowerAnalysisWizardProvider
            pathname={getQuerylessPath(router.asPath)}
            steps={meterPowerAnalysisSteps}
            routingFn={router.push}
        >
            <MeterPowerAnalysisRouteGuard steps={meterPowerAnalysisSteps} />
            <ConditionalWrapper
                Wrapper={AppLayout}
                condition={isWrapperDisplayed}
            >
                {children}
            </ConditionalWrapper>
        </MeterPowerAnalysisWizardProvider>
    )
}

MeterPowerAnalysisLayout.messages = [...AppLayout.messages] as const
